// extracted by mini-css-extract-plugin
export default {"alignItemsInCard":"StatisticsCard_alignItemsInCard__6cOZt"};